import $ from 'cash-dom';

$(function () {
	const CssPropertiesSetter = {
		_$siteHeader: $('#site-header'),
		_$homepageTitlesHolder: $('#titles-holder'),
		_$homepageCategories: $('#categories'),
		_$ftc_disclosure: $('#ftc_disclosure'),

		init() {
			this._setHeights();

			$(window).on('resize', () => {
				this._setHeights();
			});
		},

		_setHeights() {
			if (this._$siteHeader.length) {
				document.documentElement.style.setProperty('--site-header-height', this._$siteHeader.outerHeight(true) + "px");
			}

			if (this._$homepageTitlesHolder.length) {
				document.documentElement.style.setProperty('--homepage-titles-holder-height', this._$homepageTitlesHolder.outerHeight(true) + "px");
			}

			if (this._$homepageCategories.length) {
				const categoriesHeight = this._$homepageCategories.outerHeight(true);

				document.documentElement.style.setProperty('--homepage-categories-height', categoriesHeight + "px");
				document.documentElement.style.setProperty('--homepage-categories-half-height', (categoriesHeight / 2) + "px");
			}

			if (this._$ftc_disclosure.length) {
				document.documentElement.style.setProperty('--ftc-disclosure', this._$ftc_disclosure.outerHeight(true) + "px");
			}
		},
	};

	CssPropertiesSetter.init();
});
